import { render, staticRenderFns } from "./iku_opd.vue?vue&type=template&id=10aa61b4&"
import script from "./iku_opd.vue?vue&type=script&lang=js&"
export * from "./iku_opd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports